import React from "react";
import CountUp from "react-countup";
import { motion } from "framer-motion";
import { STATS } from "../../data/site";

export const Stats = () => {
  return (
    <section data-testid="stats-section" className="relative z-20 -mt-16 md:-mt-20">
      <div className="container-x">
        <div className="glass rounded-3xl px-6 md:px-10 py-10 shadow-2xl shadow-black/40">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-4 divide-white/10">
            {STATS.map((s, i) => (
              <motion.div
                key={s.label}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.1 }}
                className="text-center lg:border-l lg:border-white/10 lg:first:border-l-0 lg:px-4"
              >
                <div className="font-head text-4xl md:text-5xl font-bold text-white tracking-tight">
                  <CountUp
                    end={s.value}
                    duration={2.2}
                    decimals={s.decimals || 0}
                    enableScrollSpy
                    scrollSpyOnce
                  />
                  <span className="text-brand-orange">{s.suffix}</span>
                </div>
                <p className="mt-2 text-xs md:text-sm text-slate-400 leading-snug">{s.label}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Stats;
